/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { RESOURCE_GROUPS } from '@/features/resources/resourceLinks';
import { Modal } from './Modal';

/** Resource links dialog; opens globally to avoid resetting tool state. */
export function ResourceLinksModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose} labelledBy="res-modal-title">
      <div className="modal res-modal">
        <div className="modal-head">
          <Icon
            name="book"
            size={22}
            style={{ color: 'var(--color-primary-text)', flex: 'none' }}
          />
          <div className="mh-titles">
            <h2 id="res-modal-title">{t('resources.title')}</h2>
            <div className="mh-sub">{t('resources.subtitle')}</div>
          </div>
          <div className="sp" style={{ flex: 1 }} />
          <button className="iclose" onClick={onClose} aria-label={t('common.close')}>
            <Icon name="close" size={18} />
          </button>
        </div>

        <div className="res-modal-body">
          {RESOURCE_GROUPS.map((group) => (
            <section className="res-group" key={group.title}>
              <div className="res-group-head">
                <h2>{t(group.title)}</h2>
                <p>{t(group.description)}</p>
              </div>
              <div className="res-grid">
                {group.links.map((link) => (
                  <a
                    className="res-card"
                    href={link.href}
                    key={link.label}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="res-card-ic">
                      <Icon name={link.icon} size={20} />
                    </span>
                    <span className="res-card-main">
                      <span className="res-card-title">
                        {t(link.label)}
                        {link.badge && <span className="res-badge">{t(link.badge)}</span>}
                      </span>
                      <span className="res-card-desc">{t(link.description)}</span>
                    </span>
                    <Icon name="external" size={17} className="res-card-ext" />
                  </a>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </Modal>
  );
}
